
import { put, call, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

var packageJson = require('../../package.json');

function* partnerProfileGet(action) {
  yield put(loadingSet(true));
  const state = yield select();
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('version', packageJson.version);
    params.append('testMode', Cookies.get('TEST_MODE'));
    if (state.my.setting.profileWebmasterCheck === 0 && state.my.request.profile > 0) {
      params.append('footprintPending', 1);
    }
    else {
      params.append('footprintPending', 0);
    }
    return axios.post(config.apiUri + "member/partnerProfileApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {

    }
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}




const saga = [
  takeLatest('PARTNER_PROFILE_GET', partnerProfileGet),

];

export default saga;
